module.exports = __webpack_public_path__ + "static/prateek-927a0ceee0e0f18aa7c4509f7d7de00e.jpg";